// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-o_fV","advertDetailContacts__header":"c-o_fW"};